import React, { Component } from "react";
import ReactSelect from "react-select";

class Select extends Component {
  static defaultProps = {
    options: [],
    errors: []
  };

  state = {
    options: this.props.options,
  };

  componentDidUpdate() {}

  handleSelect = () => {};

  render() {
    const { options } = this.state;

    const styles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor:
          state.isSelected || state.isFocused ? "#74BD4C" : "#FFF",
        color: state.isSelected || state.isFocused ? "#FFF" : "#333",
      }),

      multiValue: (provided) => ({
        ...provided,
        borderRadius: 100,
        backgroundColor: "#74BD4C",
        color: "#FFF",
      }),

      multiValueLabel: (provided) => ({
        ...provided,
        color: "#FFF",
        fontSize: 12,
      }),

      multiValueRemove: (provided, state) => ({
        ...provided,
        borderTopRightRadius: 100,
        borderBottomRightRadius: 100,
        backgroundColor:
          state.isFocused || state.isSelected ? "#74BD4C" : "#74BD4C",
      }),
    };

    return (
      <div>
        <ReactSelect
          options={options}
          styles={styles}
          className="form-select"
          classNamePrefix="form-select"
          {...this.props}
        />

        {this.props.errors !== null && (
          <ul className="parsley-errors-list filled">
            {this.props.errors.map((error, index) => (
              <li className="parsley-required" key={index}>
                {error}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Form/Select/index.js